'use client'
import React, {useContext} from "react";
import IconRenderer from "@/libs/contentful/helper/IconRenderer";
import {MobileNavContext} from "@/components/Layout/Header/Navigation/MainNavProvider";
import {useTranslations} from "next-intl";

const NavBurgerButton = () => {
  const {isMobileNavExpanded, toggleMobileNav } = useContext(MobileNavContext);
  const t = useTranslations("MainMenu")

  const openNav = () => {
    toggleMobileNav(!isMobileNavExpanded)
    const sections = document.querySelectorAll('main, footer')
    sections.forEach(section => {
      const elements = section.querySelectorAll('a, button, input, textarea')
      elements.forEach(element => {
        element.toggleAttribute('inert');
      })
    })
  }

  return (
    <button
      id="navbar-button"
      onClick={() => openNav()}
      data-collapse-toggle="navbar-default"
      type="button"
      className="hover:bg-gray-100 ml-auto flex md:hidden"
      aria-controls="navbar-default"
      aria-pressed={isMobileNavExpanded ? 'true' : 'false'}
      aria-expanded={isMobileNavExpanded}
      aria-label={t("navigationToggle")}
      role="button"
    >
      <span className="sr-only">Open main menu</span>
      {isMobileNavExpanded ? <IconRenderer icon="icon-close"  className="" /> : <IconRenderer icon="icon-burger-menu"  className="" />}
    </button>
  )
}

export default NavBurgerButton
